import { ValidationService } from './../service/validation.service';
import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { CognitoService } from '../service/cognito.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../service/theme.service';
import { NavigationService } from '../service/navigation.service';
import { SystemMessageService } from '../service/system-message.service';
import { environment } from '../environments/environment';
import { Router, NavigationStart } from '@angular/router';

@Component({
    selector: 'app-entities',
    templateUrl: './entities.component.html',
    styleUrls: ['./entities.component.css'],
    standalone: false
})

export class EntitiesComponent implements OnInit {

  lastEntitiesContent:string = ''
  lastEntitiesTab:string = ''

  // Variables for user filtering
  public mainContent: string = '';

  // Flags for UI state
  public isClientsActive: boolean = false;
  public isDistributorsActive: boolean = false;
  public isProvidersActive: boolean = false;
  public isOperatorActive: boolean = false;
  public isLocationActive: boolean = false;
  private previousUrl: string | null = null;
  public isApiActive: boolean = false;

  constructor(
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private cognitoService: CognitoService,
    public validationService: ValidationService,
    public theme: ThemeService,
    public navigationService: NavigationService,
    public systemMessage: SystemMessageService,
    private router: Router

  ) {
    this.cognitoService.confirmValidUser();
  }

  ngOnInit(): void {
    // Load last-viewed tab state from local storage on entry.
    this.lastEntitiesContent = this.localStorageService.getItem('entitiesContent');
    this.lastEntitiesTab = this.localStorageService.getItem('entitiesLastTab');

    //Verifies that the current User is allowed to view this component
    this.cognitoService.getCurrentRole([environment.users.role.administrator],[environment.users.superAdmin]);//Role Check

    // displays the list of customers when the entities component is first accessed
    this.isClientsActive = true;

    switch (this.lastEntitiesContent) {

      case "clients":
        // Activate the "clients" button UI state
        this.clientsClicked();
        break;

      case "distributors":
        // Activate the "distributors" button UI state
        this.distributorsClicked();
        break;

      case "operator":
        // Activate the operator button UI state
        this.operatorClicked();
        break;

      case "locations":
        // Activate the location button UI state
        this.locationsClicked();
        break;

      case "api":
        // Activate the api button UI state
        this.apiClicked();
        break;
        
      case "deleteClientSuccess":
        // Activate the location button UI state
        this.clientsClicked();
        this.systemMessage.selectRibbon('success', "clientDeleteSuccess");
        break;

      case "deleteClientFail":
        // Activate the location button UI state
        this.clientsClicked();
        this.systemMessage.selectRibbon('danger', "clientDeleteFailed");
        break;

      case "deleteDistributorFail":
        // Activate the location button UI state
        this.distributorsClicked();
        this.systemMessage.selectRibbon('danger', "deleteDistributorFailed");
        break;

      case "deleteDistributorSuccess":
        // Activate the location button UI state
        this.distributorsClicked();
        this.systemMessage.selectRibbon('success', "distributorDeleteSuccess");
        break;

      default:
        // Prefer the last visited tab when returning from create/update pages
        const preferredTab = this.lastEntitiesTab || this.lastEntitiesContent;
        switch (preferredTab) {
          case "clients":
            this.clientsClicked();
            break;
          case "distributors":
            this.distributorsClicked();
            break;
          case "operator":
            this.operatorClicked();
            break;
          case "locations":
            this.locationsClicked();
            break;
          case "api":
            this.apiClicked();
            break;
          default:
            // Activate the "clients" button UI state as default option
            this.clientsClicked();
        }
    }

    // Check if there is a success message for distributor creation
    if (this.validationService.distributorCreateSuccessMessage) {
      // If so, display a success ribbon message with the specified key
      this.systemMessage.selectRibbon('success', "distributorCreateSuccessMessage");
    }

    // Check if there is a success message for client creation
    if (this.validationService.clientCreateSuccessMessage) {

      // If so, display a success ribbon message with the specified key
      this.systemMessage.selectRibbon('success', "clientCreateSuccessMessage");
    }

    // Check if there is a success message for client update
    if (this.validationService.clientUpdateSuccessMessage) {

      // If so, display a success ribbon message with the specified key
      this.systemMessage.selectRibbon('success', "clientUpdateSuccessMessage");
    }
    //return to operator tab when cancel button clicked in operator update and create form
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const urlFrom = window.location.pathname.toString()
        if (urlFrom.includes('/operator-update') ||
            urlFrom.includes('/operator-create')){
          this.operatorClicked()
        };
      }
    });

  }

  AfterViewInit() {
    switch (this.lastEntitiesContent) {
      case "clients":
        // Activate the "clients" button UI state
        this.clientsClicked();
        break;

      case "distributors":
        // Activate the "distributors" button UI state
        this.distributorsClicked();
        break;

      case "operator":
        // Activate the "operator" button UI state
        this.operatorClicked();
        break;

      case "locations":
        // Activate the location button UI state
        this.locationsClicked();
        break;

      case "keys":
        // Activate the location button UI state
        this.apiClicked();
        break;

      default:
        // Activate the "clients" button UI state as default option
        this.clientsClicked();
    }


  }

  // Function to clear the UI state flags for different user types
  clearButtonsStats() {
    // Deactivate the "clients" UI state
    this.isClientsActive = false;

    // Deactivate the "distributors" UI state
    this.isDistributorsActive = false;

    // Deactivate the "providers" UI state
    this.isProvidersActive  = false;

    // Deactivate the 'operator' UI state
    this.isOperatorActive = false;

    // Deactive the location UI state
    this.isLocationActive = false;

    // Deactive the key UI state
    this.isApiActive = false;
  }

  // Function to handle the "Clients" button click event
  clientsClicked(){
    // Clear the UI state flags for other user types
    this.clearButtonsStats();

    // Set the "isClientsActive" flag to indicate the "Clients" button is active
    this.isClientsActive = true;

    // Update the main content to display the content for "Clients"
    this.mainContent = "clients";

    // Update the navigation service contoller content to "Clients"
    this.localStorageService.addItem('entitiesContent', 'clients');
    this.localStorageService.addItem('entitiesLastTab', 'clients');
  }

  // Function to handle the "Distributors" button click event
  distributorsClicked() {
    // Clear the UI state flags for other user types
    this.clearButtonsStats();

    // Set the "isDistributorsActvive" flag to indicate the "Distributors" button is active
    this.isDistributorsActive = true;

    // Update the main content to display the content for "Distributors"
    this.mainContent = "distributors"

    // Update the navigation service contoller content to "Distributors"
    this.localStorageService.addItem('entitiesContent', 'distributors')
    this.localStorageService.addItem('entitiesLastTab', 'distributors')
  }

  // Function to handle the "Operator" button click event
  operatorClicked() {
    // Clear the UI state flags for other user types
    this.clearButtonsStats();

    // Set the "isProvidersActive" flag to indicate the "Providers" button is active
    this.isOperatorActive = true;

    // Update the main content to display the content for "Providers"
    this.mainContent = "operator";

    // Update the navigation service contoller content to "Providers"
    this.localStorageService.addItem('entitiesContent', 'operator');
    this.localStorageService.addItem('entitiesLastTab', 'operator');
  }

  // Function to handdle the location button UI click event
  locationsClicked(){
    // Clear the UI state flags for other user types
    this.clearButtonsStats();

    // Set the "isProvidersActive" flag to indicate the "locations" button is active
    this.isLocationActive = true;

    // Update the main content to display the content for "locations"
    this.mainContent = "locations";

    // Update the navigation service contoller content to "locations"
    this.localStorageService.addItem('entitiesContent', 'locations');
    this.localStorageService.addItem('entitiesLastTab', 'locations');
  }

  apiClicked() {
    // Clear the UI state flags for other user types
    this.clearButtonsStats();

    // Set the "isProvidersActive" flag to indicate the "locations" button is active
    this.isApiActive = true;

    // Update the main content to display the content for "locations"
    this.mainContent = "api";

    // Update the navigation service contoller content to "locations"
    this.localStorageService.addItem('entitiesContent', 'api');
    this.localStorageService.addItem('entitiesLastTab', 'api');
  }
}
